module.exports = __webpack_public_path__ + "static/media/antenna_icon.268fa23e.svg";